import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnxsummary';
export const route = 'cnxsummary/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxsummary" */
/* webpackPrefetch: true */
'../components/SummaryPage')));